<template>
  <v-container>
    <div class="back-plot">
      <!-- BOC:[error] -->
      <ApiErrorDialog v-if="api.isError" :api="api" />
      <!-- EOC -->
      <v-card class="transparent" elevation="0" v-if="classroom">
        <v-card-title class="text-h5 grey lighten-5 rounded-lg py-2">
          <v-row>
            <v-col cols="9" class="d-flex rounded align-center">
              {{ auth.User.name }}
            </v-col>
            <v-col cols="3" class="d-flex align-center justify-end">
              <CloseBtn size="40" :callback="exit" />
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
      <!-- EOC -->
      <v-card
        v-if="data"
        :class="
          settings.graphics && settings.graphics.mode == 'low'
            ? 'low_plot'
            : 'plot'
        "
        :loading="api.isLoading"
      >
        <v-card-title>{{ $t("action.linkPlayer") }}</v-card-title>
        <v-card-subtitle>
          <v-chip
            v-if="data.status == 'ACCEPTED'"
            color="success"
            small
            class="mt-2"
            >{{ $t("string.linkPlayerStatusAccepted") }}</v-chip
          >
          <v-chip
            v-else-if="data.status == 'REJECTED'"
            color="error"
            small
            class="mt-2"
            >{{ $t("string.linkPlayerStatusRejected") }}</v-chip
          >
          <v-chip
            v-else
            color="warning"
            small
            class="mt-2"
            >{{ $t("string.linkPlayerStatusPending") }}</v-chip
          >
        </v-card-subtitle>
        <v-card-text class="d-flex justify-center pa-0">
          <AbstractAvatar
            v-if="data.Player && data.Player.avatar"
            :width="100"
            :height="100"
            :avatar="data.Player.avatar"
          />
        </v-card-text>
        <v-card-text v-if="data.status == 'ACCEPTED'">
          {{
            $t("string.linkAccepted", {
              id: auth.User.RequestPlayerLink.mochiId,
            })
          }}
        </v-card-text>
        <v-card-text v-if="data.status == 'PENDING'">
          {{
            $t("string.linkPending", {
              id: auth.User.RequestPlayerLink.mochiId,
            })
          }}
        </v-card-text>
        <v-card-text v-if="data.status == 'REJECTED'">
          {{
            $t("string.linkRejected", {
              id: auth.User.RequestPlayerLink.mochiId,
            })
          }}
        </v-card-text>

        <v-card-actions class="d-flex flex-column">
          <v-btn
            rounded
            class="mx-1 mb-2"
            v-if="data.status == 'REJECTED'"
            x-large
            color="yellow"
            @click="exit"
          >
            {{ $t("action.ok") }}
          </v-btn>
          <v-btn
            @click="loginAnotherAccount"
            :loading="api.isLoading"
            rounded
            class="mx-1 mb-2"
            v-if="data.status == 'PENDING'"
            x-large
            color="yellow"
            style="text-transform: capitalize"
          >
            {{ $t("action.loginAnotherAccount") }}
          </v-btn>
          <v-btn
            @click="login"
            :loading="api.isLoading"
            rounded
            color="yellow"
            x-large
            class="mx-1 mb-2"
            style="text-transform: capitalize"
            v-if="data.status == 'ACCEPTED'"
          >
            {{ $t("action.continue") }}
          </v-btn>
          <v-btn
            @click="cancelRequest"
            :loading="api.isLoading"
            rounded
            class="mx-1 mb-2"
            text
            style="text-transform: capitalize"
            v-if="data.status == 'PENDING'"
          >
            {{ $t("action.cancelRequest") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import AvatarSkeleton from "@/components/skeleton/Avatar";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    ApiErrorDialog: () =>
      import(
        /* webpackChunkName: "component-api-error-dialog" */ "@/components/ApiErrorDialog.vue"
      ),
    AbstractAvatar: () => ({
      component: import(
        /* webpackChunkName: "component-abstract-avatar-testing" */ "@/components/avatar/AbstractAvatar"
      ),
      loading: AvatarSkeleton,
      delay: 200,
    }),
  },
  computed: mapState({
    auth: (state) => state.auth.data,
    settings: (state) => state.settings.data,
  }),
  props: [
    //
  ],
  data: () => ({
    mochiId: "",
    code: null,
    data: null,
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    classroom: {},
    //EOC
  }),
  created() {
    //
  },
  mounted() {
    this.loadRequestLink();
    if (this.auth.Group && this.auth.User.RequestPlayerLink) {
      this.code = this.auth.Group.code;
      if (this.auth && this.auth.Classroom) {
        this.classroom = this.auth.Classroom;
      }
    } else {
      this.$router.push({ name: "PageAccessMain" });
    }
  },
  methods: {
    exit() {
      if (this.auth.Group.type == "family") {
        this.$router.push({
          name: "PageAccessFamily",
        });
      } else {
        this.$router.push({
          name: "PageAccessClassroom",
        });
      }
    },
    cancelRequest() {
      this.cancelRequestLink();
    },
    loginAnotherAccount() {
      this.$store.dispatch("resetAuth");
      this.$store.dispatch("resetCoin");
      this.$store.dispatch("resetPick");
      this.$store.dispatch("resetSkin");
      this.$store.dispatch("resetApparel");
      this.$store.dispatch("resetTutorial");
      this.$store.dispatch("resetBoss");
      this.$store.dispatch("resetEvent");
      this.$store.dispatch("resetSeries");
      this.$store.dispatch("resetGameCache");
      this.$store.dispatch("resetMiniGame");
      this.$store.dispatch("resetABC");
      this.$store.dispatch("resetMath");
      this.$router.push({
        name: "PageAccessMain",
      });
    },
    loadRequestLink() {
      this.api.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/player/requestPlayerLink/load";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = (resp) => {
        this.api.isLoading = false;
        this.data = resp;
      };
      this.api.params = {
        studentId: this.auth.Group.type == "family" ? null : this.auth.User.id,
        userId: this.auth.Group.type == "family" ? this.auth.User.id : null,
      };
      this.$api.fetch(this.api);
    },
    cancelRequestLink() {
      this.api.url =
        this.$api.servers.sso +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/player/requestPlayerLink/cancel";
      this.api.callbackReset = () => {
        this.api.isLoading = true;
        this.api.isError = false;
        this.api.error = null;
      };
      this.api.callbackError = (e) => {
        this.api.isLoading = false;
        this.api.isError = true;
        this.api.error = e;
      };
      this.api.callbackSuccess = () => {
        this.api.isLoading = false;
        var authData = this.$_.cloneDeep(this.auth);
        authData.User.RequestPlayerLink = null;
        this.$store.commit("updateAuth", authData);
        this.exit();
      };
      this.api.params = {
        id: this.auth.User.RequestPlayerLink.id,
      };
      this.$api.fetch(this.api);
    },
    login() {
      var authData = this.$_.cloneDeep(this.auth);
      authData.Player = this.data.Player;
      this.$store.commit("updateAuth", authData);
      this.$router.push({
        name: "PageAccessPassword",
      });
    },
  },
};
</script>

<style scoped>
.v-card {
  display: flex !important;
  flex-direction: column;
}

.v-card__text {
  flex-grow: 1;
  overflow: auto;
}

.image1 {
  position: absolute;
  z-index: 2;
}
.image2 {
  position: absolute;
  z-index: 3;
}

.image3 {
  position: absolute;
  z-index: 1;
}

.title {
  pointer-events: none;
  font-size: 1em !important;
}
</style>